import { useState } from 'react';
import { DashboardWidgetId, DASHBOARD_WIDGETS } from '../../../pages/Home/dashboardWidgets';
import Dropdown from '../../common/Dropdown/Dropdown';
import Icon from '../../common/Icon/Icon';
import { IconKeys } from '../../common/Icon/IconKeys';
import { Button } from '../../ui/Button/Button';
import S from './DashboardWidgetPickerStyles';

type Props = {
  hiddenWidgetIds: DashboardWidgetId[];
  onAdd: (widgetId: DashboardWidgetId) => void;
};

function DashboardWidgetPicker({ hiddenWidgetIds, onAdd }: Props): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);
  const hasHiddenWidgets = hiddenWidgetIds.length > 0;

  const trigger = (
    <Button type="button" disabled={!hasHiddenWidgets} style={{ height: '26px' }}>
      <Icon iconKey={IconKeys.PLUS} />
      <p>Add widget</p>
    </Button>
  );

  if (!hasHiddenWidgets) {
    return trigger;
  }

  return (
    <S.Wrapper>
      <Dropdown isOpen={isOpen} onChange={setIsOpen} target={trigger}>
        <ul className="dashboard-widget-picker">
          {hiddenWidgetIds.map((widgetId) => (
            <li key={widgetId}>
              <button
                type="button"
                onClick={() => {
                  onAdd(widgetId);
                  setIsOpen(false);
                }}
              >
                <Icon iconKey={IconKeys.PLUS} />
                <span>{DASHBOARD_WIDGETS[widgetId].label}</span>
              </button>
            </li>
          ))}
        </ul>
      </Dropdown>
    </S.Wrapper>
  );
}

export default DashboardWidgetPicker;
